import {MomentDateAdapter} from '@angular/material-moment-adapter';
import * as moment_ from 'moment';

const moment = moment_;

export class MomentDateStrictAdapter extends MomentDateAdapter {
    /**
     * Adding string parsing to the base class function
     *  value
     *  {string | string[]} parseFormat
     *  {moment.Moment | null}
     */
    parse(value: any, parseFormat: string | string[]): moment_.Moment | null {
        if (value && typeof value == 'string') {
            if (this.locale == 'en-GB') {
                parseFormat = ['D-M-YYYY', 'D/M/YYYY', 'D.M.YYYY', 'DMYYYY'];
            }else if (this.locale == 'de-DE') {
                parseFormat = ['D.M.YYYY'];
            }
            return moment(value, parseFormat, this.locale, true);
        }
        return value ? moment(value).locale(this.locale) : null;
    }
}
